import { Component, OnInit, Input, AfterViewInit, ChangeDetectorRef } from '@angular/core';
import { InterpretationService } from '../../interpretation.service';
import { NotificationsService } from 'angular2-notifications';
import { SystemModel, UCSystemType, Side, ComponentModel, QuoteOverviewModel } from '../../models/interpretation.model';
import { DomSanitizer } from '@angular/platform-browser';
import { UserService } from '../../../../shared/services/user.service';
import { AppService } from '../../../../app.service';
import { TranslateService } from '../../../../translate';
import { CustomeEvaluationRangeVM } from '../../../CustomEval/custom-eval.model';
import { PreferencesService } from '../../../../modules/preferences/preferences.service';
import moment from 'moment';

@Component({
  selector: 'app-forecast-undercariage-detail',
  templateUrl: './forecast-undercariage-detail.component.html',
  styleUrls: ['./forecast-undercariage-detail.component.scss']

  // animations: [
  //   trigger(
  //     'slideOut', [
  //       transition(':enter', [
  //         style({ 'max-height': '0' }),
  //         animate('5s', keyframes([
  //           style({ 'max-height': '200px', offset: 0 }),
  //           style({ 'max-height': '400px', offset: 0.3 }),
  //           style({ 'max-height': '600px', offset: 0.6 }),
  //           style({ 'max-height': '1400px', offset: 0.9 }),
  //         ]))
  //       ])
  //     ]
  //   )],
  // changeDetection: ChangeDetectionStrategy.OnPush
})
export class ForecastUnderCariageDetailComponent implements OnInit, AfterViewInit {


  updateComment: string;
  @Input() inspectionId: number = -1;
  @Input() systemId: number = -1;
  @Input() refreshComponents: boolean;
  quotes: QuoteOverviewModel[] = [];
  system: SystemModel = new SystemModel();
  loadingSystems = true;
  side = 'Left';
  type = 'Chain';
  isInspector = false;
  isInterpreter = false;

  overallEval = 'U';
  overallEvalLoading = true;
  removeFlagPopup = false;
  userLanguage: string = "english";
  flag_comment: string = "";
  flag_on: boolean = false;
  selected_inspection_detail_auto: number;
  selected_track_unit_auto: number;
  userUOD: string = "km";

  @Input() InspectionSMU: number;
  @Input() EvalautionRange: CustomeEvaluationRangeVM;
  constructor(
    private _interp: InterpretationService,
    private _notify: NotificationsService,
    private _sanitizer: DomSanitizer,
    private _cdr: ChangeDetectorRef,
    private _user: UserService,
    private _translate: TranslateService,
    private _app: AppService,
    private _pref:PreferencesService
  ) { }

  checkPermissions() {
    this._user.getUserJobRoles().subscribe(
      jobRoles => {
        jobRoles.forEach(role => {
          switch (role.Name) {
            case 'Inspectors':
              this.isInspector = true;
              break;
            case 'Interpreters':
            case 'Super User':
            case 'Administrator':
              this.isInterpreter = true;
              this.isInspector = true;
              break;
            case 'Customer Admin':
              this.isInspector = true;
              this.isInterpreter = true;
              break;
          }
        });
      },
      error => {
        console.error(error);
        this._notify.error('Error', 'Unable to check your job roles. ');
      }
    );
  }
  UTEquivalenetEnabled: boolean = false;
  UTEqu: string;
  isEnableMaxRange: boolean;
  ngOnInit() {
    this.checkPermissions();
    this.loadSystem();
    //this.loadQuotes();
    this._app.getApplicationConfigValue("UTEquivalentEnabled").subscribe(result => {
      this.UTEqu = result
      if (this.UTEqu == "1") {
        this.UTEquivalenetEnabled = true;

      } else {
        this.UTEquivalenetEnabled = false;
      }

    });


    this._app.getApplicationConfigValue("EnableMaxRangeForEvaluation").subscribe(result => {

      if (result == "1") {
        this.isEnableMaxRange = true;
      } else {
        this.isEnableMaxRange = false;
      }
    });
    this.getUserUOD();
  }
  ngOnChanges() {
    
    if (this.refreshComponents) {
      // console.log("this.refreshComponents Child 2:", this.refreshComponents);
      this.loadSystem();
      this.refreshComponents = false;
    }
  }

  get panelHeading() {
    if (this.loadingSystems)
      return '';
    return this.systemSide + ' Side ' + this.systemName;
  }
  get systemSide(): string {
    switch (this.system.Side) {
      case Side.Unknown: return 'Unknown';
      case Side.Both: return 'Both';
      case Side.Left: return 'Left';
      case Side.Right: return 'Right';
    }
  }

  get systemName(): string {
    switch (this.system.Type) {

      case UCSystemType.Chain:
        return 'Chain';
      case UCSystemType.Frame:
        return 'Frame';
      default:
        return 'Chain';
    }
  }
  sanitize(image: string) {
    return this._sanitizer.bypassSecurityTrustResourceUrl(image);
  }
  showPosition(position: number, compartTypeId: number): string {
    let hasSameComponent = this.system.Components.filter(x => x.ComponentTypeId == compartTypeId && x.IsChild == false);
    if (hasSameComponent.length > 1) {
      return this.getPositionStringDoubleComponents(position, compartTypeId);
    } else {
      return this._app.getPositionString(position, compartTypeId);
    }

    // if(this.system.Components.length >4){
    //         return this.getPositionStringDoubleComponents(position,compartTypeId);
    // }else{
    //     return this._app.getPositionString(position, compartTypeId);
    // }

  }
  Translate(value: string): string {
    return this._translate.translateToLang(value, this.userLanguage);
  }
  getPositionStringDoubleComponents(Pos: number, CompartTypeId: number): string {
    if (CompartTypeId === 233) // Idler
      if (Pos === 1) return 'Front'; else if (Pos === 2) return 'Rear';
    if (CompartTypeId === 234 && Pos === 1) // Carrier roller
      return 'Front';
    if (CompartTypeId >= 230 && CompartTypeId <= 232 || CompartTypeId === 236 || CompartTypeId === 237 || CompartTypeId === 240) {// Link, Bushing, Shoe, Sprocket
      if (Pos === 1) return 'Front'; else if (Pos === 2) return 'Rear';

    }
    if (CompartTypeId == 446)
      return 'Rear'
    return Pos.toString();
  }
 
  loadSystem() {
 const today = new Date();
    this._interp.getSystemData(this.inspectionId, this.systemId, moment(today).format('MM/DD/YYYY').toString()).subscribe(system => {
      //console.log("s",system)
      this.system = system;

      this.loadingSystems = false;
      this._cdr.detectChanges();

      console.log("this.system", this.system)
      //Aditya

    });

  }
  TodayDate = new Date();

  ngAfterViewInit() {
    // this._cdr.detach();
  }

  
  GetEvalColour(comp: ComponentModel, worn: number,measurement:number) {
    if (this.EvalautionRange == null)
      return 'Eval-U';
    var compType = comp.ComponentTypeId;

    // if (measurement == -1) {
    //   return 'Eval-U';
    // }
    switch (compType) {
      case 230: //Link
        if (this.EvalautionRange.LinkC != null && this.EvalautionRange.LinkC != undefined) {
          if (worn <= this.EvalautionRange.LinkA)
            return 'Eval-A';
          else if (worn <= this.EvalautionRange.LinkB)
            return 'Eval-B';
          else if (worn <= this.EvalautionRange.LinkC)
            return 'Eval-C';
          else
            return 'Eval-X';
        } else {
          if (worn <= this.EvalautionRange.LinkA)
            return 'Eval-A';
          else if (worn <= this.EvalautionRange.LinkB)
            return 'Eval-B';
          else
            return 'Eval-X';
        }

      case 231://Bush
        if (this.EvalautionRange.BushC != null) {
          if (worn <= this.EvalautionRange.BushA)
            return 'Eval-A';
          else if (worn <= this.EvalautionRange.BushB)
            return 'Eval-B';
          else if (worn <= this.EvalautionRange.BushC)
            return 'Eval-C';
          else
            return 'Eval-X';
        } else {
          if (worn <= this.EvalautionRange.BushA)
            return 'Eval-A';
          else if (worn <= this.EvalautionRange.BushB)
            return 'Eval-B';
          else
            return 'Eval-X';
        }

      case 232: //Shoe
        if (this.EvalautionRange.ShoeC != null) {
          if (worn <= this.EvalautionRange.ShoeA)
            return 'Eval-A';
          else if (worn <= this.EvalautionRange.ShoeB)
            return 'Eval-B';
          else if (worn <= this.EvalautionRange.ShoeC)
            return 'Eval-C';
          else
            return 'Eval-X';
        } else {
          if (worn <= this.EvalautionRange.ShoeA)
            return 'Eval-A';
          else if (worn <= this.EvalautionRange.ShoeB)
            return 'Eval-B';
          else
            return 'Eval-X';
        }

      case 233://Idler
        if (this.EvalautionRange.LinkC != null && this.EvalautionRange.LinkC != undefined) {
          if (worn <= this.EvalautionRange.LinkA)
            return 'Eval-A';
          else if (worn <= this.EvalautionRange.LinkB)
            return 'Eval-B';
          else if (worn <= this.EvalautionRange.LinkC)
            return 'Eval-C';
          else
            return 'Eval-X';
        } else {
          if (worn <= this.EvalautionRange.LinkA)
            return 'Eval-A';
          else if (worn <= this.EvalautionRange.LinkB)
            return 'Eval-B';
          else
            return 'Eval-X';
        }

      case 234://carrier Roller
        if (this.EvalautionRange.CarrierRollerC != null) {
          if (worn <= this.EvalautionRange.CarrierRollerA)
            return 'Eval-A';
          else if (worn <= this.EvalautionRange.CarrierRollerB)
            return 'Eval-B';
          else if (worn <= this.EvalautionRange.CarrierRollerC)
            return 'Eval-C';
          else
            return 'Eval-X';
        } else {
          if (worn <= this.EvalautionRange.CarrierRollerA)
            return 'Eval-A';
          else if (worn <= this.EvalautionRange.CarrierRollerB)
            return 'Eval-B';
          else
            return 'Eval-X';
        }

      case 235://track Roller
        if (this.EvalautionRange.TrackRollerC != null) {
          if (worn <= this.EvalautionRange.TrackRollerA)
            return 'Eval-A';
          else if (worn <= this.EvalautionRange.TrackRollerB)
            return 'Eval-B';
          else if (worn <= this.EvalautionRange.TrackRollerC)
            return 'Eval-C';
          else
            return 'Eval-X';
        } else {
          if (worn <= this.EvalautionRange.TrackRollerA)
            return 'Eval-A';
          else if (worn <= this.EvalautionRange.TrackRollerB)
            return 'Eval-B';
          else
            return 'Eval-X';
        }
      case 236://Sprokcket
        if (this.EvalautionRange.SprocketC != null) {
          if (worn <= this.EvalautionRange.SprocketA)
            return 'Eval-A';
          else if (worn <= this.EvalautionRange.SprocketB)
            return 'Eval-B';
          else if (worn <= this.EvalautionRange.SprocketC)
            return 'Eval-C';
          else
            return 'Eval-X';
        } else {
          if (worn <= this.EvalautionRange.SprocketA)
            return 'Eval-A';
          else if (worn <= this.EvalautionRange.SprocketB)
            return 'Eval-B';
          else
            return 'Eval-X';
        }

      case 240://Elognation
        if (this.EvalautionRange.ElongationC != null) {
          if (worn <= this.EvalautionRange.ElongationA)
            return 'Eval-A';
          else if (worn <= this.EvalautionRange.ElongationB)
            return 'Eval-B';
          else if (worn <= this.EvalautionRange.ElongationC)
            return 'Eval-C';
          else
            return 'Eval-X';
        } else {
          if (worn <= this.EvalautionRange.ElongationA)
            return 'Eval-A';
          else if (worn <= this.EvalautionRange.ElongationB)
            return 'Eval-B';
          else
            return 'Eval-X';
        }

      case 417://Crawler
        if (this.EvalautionRange.CrawlerGuideC != null) {
          if (worn <= this.EvalautionRange.CrawlerGuideA)
            return 'Eval-A';
          else if (worn <= this.EvalautionRange.CrawlerGuideB)
            return 'Eval-B';
          else if (worn <= this.EvalautionRange.CrawlerGuideC)
            return 'Eval-C';
          else
            return 'Eval-X';
        } else {
          if (worn <= this.EvalautionRange.CrawlerGuideA)
            return 'Eval-A';
          else if (worn <= this.EvalautionRange.CrawlerGuideB)
            return 'Eval-B';
          else
            return 'Eval-X';
        }

      case 446://RSREAR
        if (this.EvalautionRange.RSRearIdlerC != null) {
          if (worn <= this.EvalautionRange.RSRearIdlerA)
            return 'Eval-A';
          else if (worn <= this.EvalautionRange.RSRearIdlerB)
            return 'Eval-B';
          else if (worn <= this.EvalautionRange.RSRearIdlerC)
            return 'Eval-C';
          else
            return 'Eval-X';
        } else {
          if (worn <= this.EvalautionRange.RSRearIdlerA)
            return 'Eval-A';
          else if (worn <= this.EvalautionRange.RSRearIdlerB)
            return 'Eval-B';
          else
            return 'Eval-X';
        }
      case 237://Idler

        if (worn <= 30)
          return 'Eval-A';
        else if (worn <= 50)
          return 'Eval-B';
        else if (worn <= 70)
          return 'Eval-C';
        else
          return 'Eval-X';


      default:
        break;
    }
  }

  getUserUOD(){
    this._pref.getGeneralTabPreferences().subscribe(res => {
      this.userUOD = res.UnitofDistance;
    })
  }
   // to convert distance from kilometers to miles for display purpose
  convertDistanceKmToMi(distance: number): number {
  return this.userUOD === 'km' ? distance : Math.round(distance * 0.621371 * 10) / 10;
  }


}

